// extracted by mini-css-extract-plugin
export default {"wrapper":"headerTabList_wrapper__CzsKx"};